export const ASSET_BASE_PATH = `${process.env.assetPathPrefix}/home`;

/// Experiences
export const dataModelImage = `${ASSET_BASE_PATH}/data_model.webp`;
export const collaborationImage = `${ASSET_BASE_PATH}/collaboration.webp`;
export const assetsImage = `${ASSET_BASE_PATH}/assets.webp`;
export const workspaceImage = `${ASSET_BASE_PATH}/workspace.webp`;
export const scriptingImage = `${ASSET_BASE_PATH}/scripting.webp`;
export const lightingEffectsImage = `${ASSET_BASE_PATH}/lighting_effects.webp`;
export const playersImage = `${ASSET_BASE_PATH}/players.webp`;
export const inputImage = `${ASSET_BASE_PATH}/input.webp`;

/// Studio
export const robloxStudioImage = `${ASSET_BASE_PATH}/roblox_studio.webp`;
export const scriptEditorImage = `${ASSET_BASE_PATH}/script_editor.webp`;
export const developerConsoleImage = `${ASSET_BASE_PATH}/developer_console.webp`;
export const terrainEditorImage = `${ASSET_BASE_PATH}/terrain_editor.webp`;
export const debuggingImage = `${ASSET_BASE_PATH}/debugging.webp`;
export const pluginsImage = `${ASSET_BASE_PATH}/plugins.webp`;
export const microprofilerImage = `${ASSET_BASE_PATH}/microprofiler.webp`;
export const studioShortcutsImage = `${ASSET_BASE_PATH}/studio_shortcuts.webp`;

/// Avatars
export const avatarsImage = `${ASSET_BASE_PATH}/avatars.webp`;
export const charactersImage = `${ASSET_BASE_PATH}/characters.webp`;
export const layeredClothingImage = `${ASSET_BASE_PATH}/layered_clothing.webp`;
export const npcKitImage = `${ASSET_BASE_PATH}/npc_kit.webp`;
export const headsImage = `${ASSET_BASE_PATH}/heads.webp`;
export const riggingImage = `${ASSET_BASE_PATH}/rigging.webp`;
export const animationsImage = `${ASSET_BASE_PATH}/animations.webp`;
export const characterSpecsImage = `${ASSET_BASE_PATH}/character_specs.webp`;

/// Audience Growth
export const userBaseImage = `${ASSET_BASE_PATH}/user_base.webp`;
export const promotionImage = `${ASSET_BASE_PATH}/promotion.webp`;
export const advertisingImage = `${ASSET_BASE_PATH}/advertising.webp`;
export const localizationImage = `${ASSET_BASE_PATH}/localization.webp`;
export const analyticsEssentialsImage = `${ASSET_BASE_PATH}/analytics_essentials.webp`;

// Design For Engagement
export const socialDesignImage = `${ASSET_BASE_PATH}/social_design.webp`;
export const eventSequencerImage = `${ASSET_BASE_PATH}/event_sequencer.webp`;
export const eventsImage = `${ASSET_BASE_PATH}/events.webp`;
export const contentUpdatesImage = `${ASSET_BASE_PATH}/content_updates.webp`;
export const coreLoopsImage = `${ASSET_BASE_PATH}/core_loops.webp`;
export const subscriptionDesignImage = `${ASSET_BASE_PATH}/subscription_design.webp`;

// Experience section
export const studioUpsellImage = `${ASSET_BASE_PATH}/studio_upsell.webp`;

// Banner
export const benchmarkInsightsDarkImage = `${ASSET_BASE_PATH}/banners/benchmark_insights_dark.webp`;
export const benchmarkInsightsLightImage = `${ASSET_BASE_PATH}/banners/benchmark_insights_light.webp`;
export const economyFunnelEventsDarkImage = `${ASSET_BASE_PATH}/banners/economy_funnel_events_dark.webp`;
export const economyFunnelEventsLightImage = `${ASSET_BASE_PATH}/banners/economy_funnel_events_light.webp`;
export const eventsUpsellDarkImage = `${ASSET_BASE_PATH}/banners/events_upsell_dark.webp`;
export const eventsUpsellLightImage = `${ASSET_BASE_PATH}/banners/events_upsell_light.webp`;
export const thumbnailPersonalizationDarkImage = `${ASSET_BASE_PATH}/banners/thumbnail_personalization_dark.webp`;
export const thumbnailPersonalizationLightImage = `${ASSET_BASE_PATH}/banners/thumbnail_personalization_light.webp`;

// Video Onboarding
export const studioLogoSvg = {
  light: `https://cdn.foundation.${process.env.robloxSiteDomain}/current/StudioLogo-Light.svg`,
  dark: `https://cdn.foundation.${process.env.robloxSiteDomain}/current/StudioLogo-Dark.svg`,
} as const;
export const yourPlaceImage = `${ASSET_BASE_PATH}/your_place_thumbnail.webp`;
export const yourPlaceThumbnail = `${ASSET_BASE_PATH}/your_place_thumbnail.png`;
export const yourPlaceIcon = `${ASSET_BASE_PATH}/your_place_icon.png`;
export const youtubeHash = 'vIiVbFiDbBE';

// Beginner Tools
export const learnWithAssistantDarkImage = `${ASSET_BASE_PATH}/learn_with_assistant_dark.webp`;
export const browseStoreDarkImage = `${ASSET_BASE_PATH}/browse_store_dark.webp`;
export const learnWithAssistantLightImage = `${ASSET_BASE_PATH}/learn_with_assistant_light.webp`;
export const browseStoreLightImage = `${ASSET_BASE_PATH}/browse_store_light.webp`;
export const buildWithRobloxImage = `${ASSET_BASE_PATH}/build_with_roblox.webp`;
